module.exports = __webpack_public_path__ + "static/media/coffee.0f940452.svg";